<div
    class="header mat-elevation-z2"
    fxLayout="row"
    fxLayoutAlign="space-between center"
>
    <div class="logo__container">
        <img class="logo" src="../../../../assets/Logo.svg" />
        <div class="logo__divider"></div>
        <p class="student__portal__title">{{ "Student Portal" | translate }}</p>
    </div>
    <!-- Section - If the user is not signed in -->
    <div
        fxLayout="row"
        fxLayoutGap="0.5rem"
        *ngIf="!signedInUser"
        class="lang-col"
    >
        <!-- <button
            (click)="onHelpDeskClick()"
            class="help__button"
            [matTooltip]="'Help Desk' | translate"
        >
            <mat-icon>help_outline</mat-icon>
        </button> -->
        <!-- Language selector on small view -->
        <div class="language__container__small">
            <div>
                <!-- (click)="setLang('fr')" -->
                <button
                    mat-button
                    class="lang"
                    [ngClass]="{
                        'lang-selected': lang.currentLang === 'en'
                    }"
                    (click)="setLang('fr')" 
                    *ngIf="lang.currentLang === 'en'"
                >
                    Fr
                </button>
                <button
                    mat-button
                    class="lang"
                    [ngClass]="{
                        'lang-selected': lang.currentLang === 'fr'
                    }"
                    (click)="setLang('en')"
                    *ngIf="lang.currentLang === 'fr'"
                >
                    En
                </button>
            </div>
        </div>
        <!-- Language selector on medium view -->
        <div class="language__container__medium">
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="0.5rem"
                style="margin: 0.5rem 0"
            >
                <button
                    mat-button
                    class="lang"
                    [ngClass]="{
                        'lang-selected': lang.currentLang === 'en'
                    }"
                    (click)="setLang('en')"
                >
                    En
                </button>
                <p class="lang__divider">|</p>
                <button
                    mat-button
                    class="lang"
                    [ngClass]="{
                        'lang-selected': lang.currentLang === 'fr'
                    }"
                    (click)="setLang('fr')"
                >
                    Fr
                </button>
                <!-- (click)="setLang('fr')" -->
            </div>
        </div>
        <button mat-button color="primary" (click)="onLogin()">
            {{ "Sign in" | translate }}
        </button>
    </div>
    <!-- End Section - If the user is not signed in -->

    <!-- Section - If user is signed in -->
    <div
        fxLayout="row"
        style="height: 100%"
        fxLayoutGap="0.5rem"
        *ngIf="signedInUser"
    >
        <!-- <button
            (click)="onHelpDeskClick()"
            class="help__button"
            [matTooltip]="'Help Desk' | translate"
        >
            <mat-icon>help_outline</mat-icon>
        </button> -->
        <button
            class="notifications-icon__container"
            mat-button
            style="min-width: 2rem; min-height: 100%; border-radius: 0"
            (click)="onNotificationClick()"
        >
            <div
                style="
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
            >
                <mat-icon class="notification__icon" style="margin: 0"
                    >notifications_none
                </mat-icon>
                <span
                    class="notification__icon-dot"
                    *ngIf="newNotifications"
                ></span>
            </div>
        </button>

        <!-- Mat Menu should be a button not div to allow accesibility -->
        <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="user__container"
            aria-label="Navigation Bar Menu"
        >
            <div class="user-profile-item">
                <div>
                    <h4 class="users-name">
                        {{ signedInUser.firstName }}
                        {{ signedInUser.lastName[0] }}.
                    </h4>
                </div>
                <mat-icon *ngIf="studentProfile?.avatarId == 0 || !hasAvatar" class="avatar-icon">account_circle_outline</mat-icon>
                <img *ngIf="studentProfile?.avatarId != 0 && hasAvatar" [src]="avatarUrl | safeHtml" class="avatar"/>
                <mat-icon class="down-arrow-icon">keyboard_arrow_down</mat-icon>
            </div>
        </button>

        <mat-menu #menu="matMenu">
            <div>
                <h4 class="users-name-in-menu">
                    {{ signedInUser.firstName }} {{ signedInUser.lastName }}
                </h4>
                <button
                    mat-menu-item
                    style="width: 100%"
                    routerLink="/profile/"
                >
                    <div class="button-text__wrapper">
                        <mat-icon class="menu-icon">account_circle</mat-icon>
                        {{ "My Profile" | translate }}
                    </div>
                </button>
                <button
                    mat-menu-item
                    style="width: 100%"
                    routerLink="/myyouthworker/"
                >
                    <div class="button-text__wrapper">
                        <mat-icon class="menu-icon">person_outline</mat-icon>
                        <span class="menu-text">{{ "My Youth Worker" | translate }}</span>
                    </div>
                </button>
                <button mat-menu-item style="width: 100%" (click)="onLogout()">
                    <div class="button-text__wrapper">
                        <mat-icon class="menu-icon">logout</mat-icon>
                        {{ "Log out" | translate }}
                    </div>
                </button>
                <div class="language__container__signed__in">
                    <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="0.5rem"
                        style="margin: 0.5rem 0"
                    >
                        <button
                            mat-button
                            class="lang"
                            [ngClass]="{
                                'lang-selected': lang.currentLang === 'en'
                            }"
                            (click)="setLang('en')"
                        >
                            En
                        </button>
                        <p class="lang__divider">|</p>
                        <button
                            mat-button
                            class="lang"
                            [ngClass]="{
                                'lang-selected': lang.currentLang === 'fr'
                            }"
                            (click)="setLang('fr')"
                        >
                            Fr
                        </button>
                        <!-- (click)="setLang('fr')" -->
                    </div>
                </div>
            </div>
        </mat-menu>
    </div>
    <!-- End Section - If user is signed in -->
</div>
